import { STATUS_AGENDA_META, type StatusAgendamento } from "../types";

/** Status do agendamento por forma (glifo) + rótulo + cor calma — nunca vermelho. */
export function StatusAgendaBadge({ status }: { status: StatusAgendamento }) {
  const m = STATUS_AGENDA_META[status];
  return (
    <span className={`badge ${m.classe}`}>
      <span className="glifo" aria-hidden>
        {m.glifo}
      </span>
      {m.rotulo}
    </span>
  );
}
